import React, { useEffect, useState } from "react";
import { axiosInstance } from "../Api/instance";
import "./style.css";

const TAB_API = {
  subject: "get/U_SubjectRank.php",
  nonnursing: "get/U_NonNursingRank.php",
  model: "get/U_ModelMockRank.php",
  premium: "get/U_Leaderboard_Premium.php",
  mains: "get/U_Leaderboard_Mains.php",
};

export default function Leaderboard() {
  const [activeTab, setActiveTab] = useState("subject");
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLeaderboard(activeTab);
  }, [activeTab]);

  const fetchLeaderboard = async (type) => {
    try {
      setLoading(true);

      const userId = localStorage.getItem("userMail"); // 👈 get logged user id

      const res = await axiosInstance.post(TAB_API[type], {
        userId: userId, // 👈 payload
      });

      if (Array.isArray(res.data)) {
        setData(res.data); // TOP 5 only
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Leaderboard error:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

const filteredData = data.filter((d) =>
  (d.name || d.student_name || "").toLowerCase().includes(search.toLowerCase()),
);


  return (
    <div className="leaderboard-box">
      <div className="leaderboard-header">
        <h4>Leaderboard</h4>

        <input
          placeholder="Search name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="tabs">
        {["subject", "nonnursing", "model", "premium", "mains"].map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>

      {loading ? (
        <p style={{ textAlign: "center" }}>Loading...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>sno</th>
              <th>Name</th>
              <th>Total</th>
              <th>Papers</th>
              <th>Rank</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length ? (
              filteredData.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{row.student_name}</td>
                  <td>{row.total_score}</td>
                  <td>{row.papers}</td>
                  <td>{row.rank}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
